export default {
    namespaced: true,
    state: {
        // 判断登录Ajax是否完成
        loginAjaxComplete: false,// false-未完成、true-完成
        // 登录框显示
        loginIsShow: false,
        // 国外用户是否在个人中心
        personalCenter: false,
        // 登录数据
        loginData: {
            loginType: false,// 登录状态
            headPortrait: '',// 用户头像URL
            userType: '',// 用户分类（已登录返回） 0-企业买家、1-合伙人用户、2-供应商账户、3-个人卖家、4-企业供应商代理人、5-海外企业用户、6-个人买家
            username: '',// 用户名（已登录返回）
            nickname: '',// 用户昵称（已登录返回）若无 返回：暂未设置昵称
            overseasType: null,// 海外用户标志 false-中国大陆、true-非中国大陆
            currencyType: 'CNY',// 海外用户币制 CNY-人民币、USD-美金、EUR-欧元
            isFirstCert: '',// 企业买家和海外企业用户是否第一次申请协议认证（已登录返回） 0-第一次、1-不是第一次
            companyName: '',// 公司名称
            mobile: '',// 手机号（不加密）
            interested: '',// 是否选过感兴趣的信息 0-N、1-Y
            exportPayMethod: '',// 出口结算方式 0-付买、1-月结
            exportAccount: '',// 出口账户 0-N、1-Y
            importAccount: '',// 进口账户 0-N、1-Y
            exportMain: '',// 出口主账户 0-N、1-Y
            importMain: '',// 进口主账户 0-N、1-Y
            completeRegisterType: '',// 补全注册信息类型 0-未提交完善信息、1-无协议认证通过、2-有协议认证通过
        }
    },
    mutations: {
        // 判断登录Ajax是否完成
        loginAjaxComplete(state, value) {
            state.loginAjaxComplete = value;
        },
        // 切换登录框显示状态
        loginIsShow(state, value) {
            state.loginIsShow = value;
        },
        // 切换登录框显示状态
        personalCenter(state, value) {
            state.personalCenter = value;
        },
        // 修改登录数据
        loginData(state, value) {
            // 判断头像
            if (!value.headPortrait) {
                value.headPortrait = 'default.png';
            }
            state.loginData = value;
        }
    }
};
